

import React, { useState, useEffect } from "react";
import PaystackCheckout from "./PaystackCheckout";
import "./Billing.css";
import { secureStorage } from "./utils/secureStorage";


const API_BASE_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";

const Billing = () => {
  const userEmail = secureStorage.getItem("email") || "test@example.com";
  const userName = userEmail;
  const userPhone = "08012345678";
  const orgId = parseInt(secureStorage.getItem("organization_id")) || 1;
  const orgName = secureStorage.getItem("organization_name") || "Unknown Organization";
  const currentPlan = secureStorage.getItem("tier") || "Free";

  
  const plans = [
    {
      name: "Basic",
      monthly: 2000,
      yearly: 2000 * 12 * 0.8,
      features: ["5 Tables", "500MB storage", "50,000 Tokens/User"],
    },
    {
      name: "Pro",
      monthly: 10000,
      yearly: 10000 * 12 * 0.8,
      features: ["15 Tables", "5GB storage", "200,000 Tokens/User"],
    },
    {
      name: "Enterprise",
      monthly: 50000,
      yearly: 50000 * 12 * 0.8,
      features: ["30 Tables", "10GB+ storage", "1,000,000 Tokens/User"],
    },
  ];

  const defaultPlan = plans.find((plan) => plan.name === currentPlan) || plans[0];
  const [selectedPlan, setSelectedPlan] = useState(defaultPlan);
  const [duration, setDuration] = useState("monthly");
  const [userCount, setUserCount] = useState(1);
  const [additionalUsers, setAdditionalUsers] = useState(1);
  const [currentMaxUsers, setCurrentMaxUsers] = useState(1);

  useEffect(() => {
    // Optional: fetch current max_users from localStorage if available
    const maxUsersFromStorage = parseInt(secureStorage.getItem("max_users"));
    if (!isNaN(maxUsersFromStorage) && maxUsersFromStorage > 0) {
      setCurrentMaxUsers(maxUsersFromStorage);
      setUserCount(maxUsersFromStorage);
    }
  }, []);


  const formatCurrency = (num) =>
    num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  const durationMonths = duration === "monthly" ? 1 : 12;
  const totalAmount = selectedPlan[duration] * userCount;
  const topupPlan = plans.find((plan) => plan.name === currentPlan);
  const topupAmount = topupPlan ? topupPlan[duration] * additionalUsers : 0;

  const handleUserCountChange = (value) => {
    const num = Number(value);
    if (num >= currentMaxUsers) {
      setUserCount(num);
    } else {
      alert(`🚫 You currently have ${currentMaxUsers} user(s). You cannot downgrade.`);
    }
  };

  return (
    <div className="billing-section">
      <h2 className="billing-heading">Choose a Plan</h2>

      {/* Duration Toggle */}
      <div className="duration-toggle">
        {["monthly", "yearly"].map((dur) => (
          <button
            key={dur}
            onClick={() => setDuration(dur)}
            className={`duration-btn ${duration === dur ? "selected" : ""}`}
          >
            {dur === "yearly" ? "Yearly (20% off)" : "Monthly"}
          </button>
        ))}
      </div>

      {/* Plan Cards */}
      <div className="plan-options">
        {plans.map((plan) => (
          <div
            key={plan.name}
            onClick={() => setSelectedPlan(plan)}
            className={`plan-card ${selectedPlan.name === plan.name ? "selected" : ""}`}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") setSelectedPlan(plan);
            }}
          >
            <h3>{plan.name}</h3>
            <p>
              NGN {formatCurrency(plan[duration])}
              <small> per user / {duration === "monthly" ? "month" : "year"}</small>
            </p>
            <ul>
              {plan.features.map((feature, i) => (
                <li key={i}>{feature}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* User Count Input */}
      <div className="user-count-input">
        <label htmlFor="userCount">
          Number of Users:
          <input
            type="number"
            id="userCount"
            min={currentMaxUsers}
            value={userCount}
            onChange={(e) => handleUserCountChange(e.target.value)}
          />
        </label>
      </div>

      {/* Checkout Summary */}
      <div className="checkout-box">
        <h3>
          {userCount} user{userCount > 1 && "s"} on{" "}
          <span className="plan-name">{selectedPlan.name}</span> — NGN{" "}
          {formatCurrency(totalAmount)}{" "}
          <small>total for {duration === "monthly" ? "1 month" : "12 months"}</small>
        </h3>

        <PaystackCheckout
          userEmail={userEmail}
          userName={userName}
          userPhone={userPhone}
          planAmount={totalAmount}
          selectedPlanName={selectedPlan.name}
          orgId={orgId}
          orgName={orgName}
          durationMonths={durationMonths}
          userCount={userCount}
          isUserTopup={false}
        />
      </div>

      {/* --- Add Additional Users --- */}
      {currentPlan !== "Free" && topupPlan && (
        <div className="add-users-section">
          <h3>Add Users to Your Current Plan ({topupPlan.name})</h3>
          <label>
            Additional Users:
            <input
              type="number"
              min={1}
              value={additionalUsers}
              onChange={(e) => setAdditionalUsers(Number(e.target.value))}
            />
          </label>
          <p>
            Price per user: NGN {formatCurrency(topupPlan[duration])}
          </p>
          <p>
            Total: NGN {formatCurrency(topupAmount)} for {additionalUsers} user
            {additionalUsers > 1 ? "s" : ""} (
            {duration === "monthly" ? "1 month" : "12 months"})
          </p>

          <PaystackCheckout
            userEmail={userEmail}
            userName={userName}
            userPhone={userPhone}
            planAmount={topupAmount}
            selectedPlanName={topupPlan.name}
            orgId={orgId}
            orgName={orgName}
            durationMonths={durationMonths}
            userCount={additionalUsers}
            isUserTopup={true}
          />
        </div>
      )}
    </div>
  );
};

export default Billing;


